import { render, staticRenderFns } from "./InquiriesGuide.vue?vue&type=template&id=69bd8592&scoped=true&"
import script from "./InquiriesGuide.vue?vue&type=script&lang=js&"
export * from "./InquiriesGuide.vue?vue&type=script&lang=js&"
import style0 from "./InquiriesGuide.vue?vue&type=style&index=0&id=69bd8592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bd8592",
  null
  
)

export default component.exports